<template>
  <div class="relative" ref="hrsysNavContainer">
    <div class="vx-navbar-wrapper">
      <vs-navbar :class="classObj" :color="navbarColor" class="vx-navbar navbar-custom">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon @click.stop="showSidebar" class="sm:inline-flex xl:hidden cursor-pointer mr-1"
                      icon="MenuIcon"></feather-icon>

        <portal-target name="hrsys-navbar"></portal-target>
        <portal-target name="hrsys-navbar-actions"></portal-target>
        <template v-if="breakpoint != 'md'">

        </template>


        <vs-spacer></vs-spacer>

        <!-- NOTIFICATIONS -->
        <vs-dropdown class="cursor-pointer ml-4" vs-custom-content vs-trigger-click>
          <feather-icon :badge="unreadNotifications.length" class="cursor-pointer mt-1 sm:mr-6 mr-2"
                        icon="BellIcon"></feather-icon>
          <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

            <div class="notification-top text-center p-5 bg-primary text-white">
              <h3 class="text-white">{{ unreadNotifications.length }} New</h3>
              <p class="opacity-75">App Notifications</p>
            </div>

            <VuePerfectScrollbar :settings="settings" class="scroll-area--nofications-dropdown p-0 mb-10"
                                 ref="mainSidebarPs">
              <ul class="bordered-items">
                <li :key="ntf.index" class="flex justify-between px-4 py-4 notification cursor-pointer"
                    v-for="ntf in unreadNotifications">
                  <div @click="onNotificationClick(ntf)">
                    <div class="flex items-start">
                      <feather-icon :icon="ntf.icon"
                                    :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"/>
                      <div class="mx-2">
                        <span :class="[`text-${ntf.category}`]" class="font-medium block notification-title">{{ ntf.title }}</span>
                        <small>{{ ntf.msg }}</small>
                      </div>
                    </div>
                    <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.sent_at) }}</small>
                  </div>
                </li>
              </ul>
            </VuePerfectScrollbar>
            <div @click="viewAllNotifications" class="checkout-footer
                        fixed
                        bottom-0
                        rounded-b-lg
                        text-primary
                        w-full
                        p-2
                        font-semibold
                        text-center
                        border
                        border-b-0
                        border-l-0
                        border-r-0
                        border-solid
                        d-theme-border-grey-light
                        cursor-pointer">
              <span>View All Notifications</span>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- USER META -->
        <div class="the-navbar__user-meta flex items-center">
          <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold">{{ user_displayName }}</p>
          </div>
          <vs-dropdown class="cursor-pointer" vs-custom-content vs-trigger-click>
            <div class="con-img ml-3">
              <BaseImg
                :src="activeUserImg"
                alt="user-img"
                class="rounded-full shadow-md cursor-pointer block"
                height="40"
                key="onlineImg"
                width="40"/>
            </div>
            <vs-dropdown-menu class="vx-navbar-dropdown">
              <ul style="min-width: 9rem">
                <li @click="goToProfile" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                  <feather-icon icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">{{ $t('users.profile')}}</span></li>
                <li @click="goToChangePassword"
                    class="flex py-2 whitespace-pre px-4 cursor-pointer hover:bg-primary hover:text-white">
                  <feather-icon icon="KeyIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">{{ $t('users.changePassword')}}</span></li>
                <vs-divider class="m-1"></vs-divider>
                <li @click="logout()"
                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                  <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">{{ $t('users.logout')}}</span></li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

      </vs-navbar>
    </div>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import {PortalTarget} from 'portal-vue'
  import {mapGetters} from 'vuex';
  import Notifications from "../../services/Notifications";

  export default {
    name: "the-navbar",
    props: {
      navbarColor: {
        type: String,
        default: "#fff",
      },
    },
    data () {
      return {
        navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
        searchQuery: '',
        showFullSearch: false,
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
        autoFocusSearch: false,
        showBookmarkPagesDropdown: false,
      }
    },
    watch: {
      '$route' () {
        if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
      }
    },
    computed: {
      ...mapGetters({
        unreadNotifications: 'unreadNotifications'
      }),
      // HELPER
      sidebarWidth () {
        return this.$store.state.sidebarWidth;
      },
      breakpoint () {
        return this.$store.state.breakpoint;
      },

      // NAVBAR STYLE
      classObj () {
        if (this.sidebarWidth == "default") return "navbar-default"
        else if (this.sidebarWidth == "reduced") return "navbar-reduced"
        else if (this.sidebarWidth) return "navbar-full"
        else {
          return null
        }
      },

      // BOOKMARK & SEARCH
      data () {
        return this.$store.state.navbarSearchAndPinList
      },
      starredPages () {
        return this.$store.state.starredPages
      },
      starredPagesLimited: {
        get () {
          return this.starredPages.slice(0, 10)
        },
        set (list) {
          this.$store.dispatch('arrangeStarredPagesLimited', list)
        }
      },
      starredPagesMore: {
        get () {
          return this.starredPages.slice(10);
        },
        set (list) {
          this.$store.dispatch('arrangeStarredPagesMore', list)
        }
      },

      // PROFILE
      user_displayName () {
        return this.$store.state.me.name
      },
      activeUserImg () {
        return this.$store.state.me.avatar
      }
    },
    methods: {
      logout () {
        this.$router.push('/pages/login')
        this.$store.dispatch('logout')
      },
      showSidebar () {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
      },
      selected (item) {
        this.$router.push(item.url)
        this.showFullSearch = false
      },
      actionClicked (item) {
        // e.stopPropogation();
        this.$store.dispatch('updateStarredPage', {index: item.index, val: !item.highlightAction})
      },
      showNavbarSearch () {
        this.showFullSearch = true
      },
      showSearchbar () {
        this.showFullSearch = true
      },
      elapsedTime (startTime) {
        let x = new Date(startTime)
        let now = new Date();
        var timeDiff = now - x
        timeDiff /= 1000;

        var seconds = Math.round(timeDiff);
        timeDiff = Math.floor(timeDiff / 60);

        var minutes = Math.round(timeDiff % 60);
        timeDiff = Math.floor(timeDiff / 60);

        var hours = Math.round(timeDiff % 24);
        timeDiff = Math.floor(timeDiff / 24);

        var days = Math.round(timeDiff % 365);
        timeDiff = Math.floor(timeDiff / 365);

        var years = timeDiff;

        if (years > 0) {
          return years + (years > 1 ? ' Years ' : ' Year ') + 'ago';
        } else if (days > 0) {
          return days + (days > 1 ? ' Days ' : ' Day ') + 'ago';
        } else if (hours > 0) {
          return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago';
        } else if (minutes > 0) {
          return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago';
        } else if (seconds > 0) {
          return seconds + (seconds > 1 ? ` sec ago` : 'just now');
        }

        return 'Just Now'
      },
      goToProfile () {
        this.closePopup();
        this.$router.push('/profile');
      },
      goToChangePassword () {
        this.closePopup();
        this.$router.push('/change-password');
      },
      onNotificationClick (notification) {
        this.$store.dispatch('markNotificationAsRead', notification);
        Notifications.manageRedirection(notification, this);
      },
      closePopup () {
        this.$refs.hrsysNavContainer.click();
      },
      viewAllNotifications () {
        this.closePopup();
        this.$router.push('/notifications');
      }
    },
    directives: {
      'click-outside': {
        bind: function (el, binding) {
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler
          document.addEventListener('click', handler)
        },

        unbind: function (el) {
          document.removeEventListener('click', el.__vueClickOutside__)
          el.__vueClickOutside__ = null

        }
      }
    },
    components: {
      PortalTarget,
      VuePerfectScrollbar,
    },
  }
</script>
